import { useState } from "react";
import { Header } from "@/components/home/Header";
import { Hero } from "@/components/home/Hero";
import { Servizi } from "@/components/home/Servizi";
import { SostituzioneCaldaie } from "@/components/home/SostituzioneCaldaie";
import { PercheNoi } from "@/components/home/PercheNoi";
import { RichiestaForm } from "@/components/home/RichiestaForm";
import { Recensioni } from "@/components/home/Recensioni";
import { ZonaServita } from "@/components/home/ZonaServita";
import { Consiglia } from "@/components/home/Consiglia";
import { Footer } from "@/components/home/Footer";
import { MobileBar } from "@/components/home/MobileBar";
import { AssistenteChat } from "@/components/home/AssistenteChat";

export default function Home() {
  const [chatOpen, setChatOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const usaChatNelModulo = (testo) => {
    setPrefill({ descrizione: testo, t: Date.now() });
    setChatOpen(false);
    document.getElementById("richiesta")?.scrollIntoView({ behavior: "smooth" });
  };

  const preventivoCaldaia = () => {
    setPrefill({ tipo_problema: "Sostituzione caldaia", urgenza: "programmato", descrizione: "Vorrei un preventivo per la sostituzione della caldaia. Marchio preferito (BAXI, IMMERGAS, BOSCH): ", t: Date.now() });
    document.getElementById("richiesta")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen pb-20 md:pb-0" data-testid="home-page">
      <Header />
      <main>
        <Hero onOpenChat={() => setChatOpen(true)} />
        <Servizi />
        <SostituzioneCaldaie onPreventivo={preventivoCaldaia} />
        <PercheNoi />
        <ZonaServita />
        <Recensioni />
        <RichiestaForm prefill={prefill} />
        <Consiglia />
      </main>
      <Footer />
      <MobileBar />
      <AssistenteChat open={chatOpen} setOpen={setChatOpen} onUsaNelModulo={usaChatNelModulo} />
    </div>
  );
}
